import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { AppService } from "../../app.service";
import { UTILITIES } from "../../core/utility/utilities";

import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
// import { LaunchReview } from '@ionic-native/launch-review/ngx';

@Component({
  selector: 'app-user-details-popup',
  templateUrl: './user-details-popup.component.html',
  styleUrls: ['./user-details-popup.component.scss'],
})
export class UsetDetailsPopupComponent implements OnInit {

  page: number = 1;
  comments: string = "";
  rate: number;
  @ViewChild('rating') rating: any;
  name = '';
  // firstName = '';
  // lastName = '';
  isIOS = this.utilities.isDeviceiOS();

  constructor(
    public modalController: ModalController,
    private appService: AppService,
    private utilities: UTILITIES,
    private iab: InAppBrowser,
    // private launchReview: LaunchReview
  ) { }

  ngOnInit() { }

  ionViewWillEnter(){

  }

  chageName(ev){
    this.name = ev.detail.value;
  }

  // chageLastName(ev){
  //   this.lastName = ev.detail.value;
  // }

  doUpdateValue(){
    console.log("Name ", this.name);
    let name = this.name.split(/ (.+)/);
    let data = {
      'FirstName': name[0],
      'LastName': name[1] ? name[1] : ""
    }
    this.modalController.dismiss(data);
  }

}
